import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Lichter")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Markisen")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Storen")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Temperatur")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_grid_item = _resolveComponent("n-grid-item")!
  const _component_n_grid = _resolveComponent("n-grid")!

  return (_openBlock(), _createBlock(_component_n_grid, { cols: 2 }, {
    default: _withCtx(() => [
      _createVNode(_component_n_grid_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_card, {
            class: "card-header-truncate",
            "theme-overrides": {
          color: _ctx.themeVars.primaryColor,
          titleTextColor: 'white',
        },
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getAssets(['F@H - Dimm Actuator', 'F@H - Switch Actuator'])))
          }, {
            header: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["theme-overrides"])
        ]),
        _: 1
      }),
      _createVNode(_component_n_grid_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_card, {
            class: "card-header-truncate",
            "theme-overrides": {
          color: _ctx.themeVars.primaryColor,
          titleTextColor: 'white',
        },
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getAssets(['F@H - Awning Actuator'])))
          }, {
            header: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["theme-overrides"])
        ]),
        _: 1
      }),
      _createVNode(_component_n_grid_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_card, {
            class: "card-header-truncate",
            "theme-overrides": {
          color: _ctx.themeVars.primaryColor,
          titleTextColor: 'white',
        },
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getAssets(['F@H - Shutter Actuator', 'F@H - Blind Actuator'])))
          }, {
            header: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["theme-overrides"])
        ]),
        _: 1
      }),
      _createVNode(_component_n_grid_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_card, {
            class: "card-header-truncate",
            "theme-overrides": {
          color: _ctx.themeVars.primaryColor,
          titleTextColor: 'white',
        },
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getAssets(['F@H - Room Controller'])))
          }, {
            header: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["theme-overrides"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}